import React, { useState } from "react";
import { Form, Row, Col } from "react-bootstrap";
import { useForm } from "react-hook-form";
import { Modal, ModalBody, ModalHeader } from "reactstrap";
import axios from "axios";


const UpdateSeller = (props) => {
  const { handleSubmit } = useForm();
  const data = props.data;
  const handleInputChange = props.handleInputChange
  const modal1 = props.modal1;
  const setModal1 = props.setModal1;
  const setModal = props.setModal;
  const handleFormSubmit = props.handleFormSubmit;
  const handleUpdate = props.handleUpdate;
  const name = props.name
  const domain = props.domain
  const sellerType = props.sellerType
  const setName = props.setName
  const setDomain = props.setDomain
  const setSellerType = props.setSellerType
  const sellerID = props.sellerID;

  const sellerTypeOptions = [
    { value: "PUBLISHER", label: "PUBLISHER" },
    { value: "INTERMEDIARY", label: "INTERMEDIARY" },
    { value: "BOTH", label: "BOTH" },
  ];


  return (
    <div>
      <Modal size="lg" isOpen={modal1} toggle={() => setModal(!modal1)}>
        <ModalHeader toggle={() => setModal1(!modal1)}>
          Update Seller
        </ModalHeader>
        <ModalBody>
          <form >
            <div className="input-group input-group-outline my-3">
              <input
                type="text"
                className="form-control"
                placeholder="Seller ID"
                name="Seller ID"
                disabled
                value={sellerID}
              />
            </div>
            <div className="input-group input-group-outline my-3">
              <input
                type="text"
                className="form-control"
                placeholder="Name"
                name="Name"
                value={name}
                onChange={(e) => setName(e.target.value)}
              />
            </div>
            <div className="input-group input-group-outline mb-3">
              <input
                type="text"
                className="form-control"
                placeholder="domain"
                name="domain"
                value={domain}
                onChange={(e) => setDomain(e.target.value)}
              />
            </div>
            <div className="input-group input-group-outline mb-3">
              <Form.Control
                as="select"
                className="form-control"
                value={sellerType}
                onChange={(e) => {setSellerType(e.target.value);}}
              >
                {sellerTypeOptions.map((option) => (
                  <option key={option.value} value={option.value}>
                    {option.label}
                  </option>
                ))}
              </Form.Control>
            </div>
            <div className="text-center">
              <button
                type="submit"
                className="btn bg-gradient-info  w-15 my-5 mb-2"
                onClick={(e) => handleUpdate(e)}
              >
                Update
              </button>
            </div>
          </form>
        </ModalBody>
      </Modal>
    </div>
  );
};

export default UpdateSeller;
